import clsx from "clsx"
import JSON5 from "json5"
import React from "react"
import {useSelector} from "react-redux"
import {Hidden} from "@material-ui/core"
import Footer from "../../partials/Footer"
import {useLocation} from "react-router-dom"
import SideBar from "../../partials/SideBar"
import ContentLoader from "../../../ContentLoader"
import SidebarHeader from "../../partials/SidebarHeader"
import makeStyles from "@material-ui/core/styles/makeStyles"
import CmtHeader from "../../../../../@coremat/CmtLayouts/Vertical/Header"
import CmtFooter from "../../../../../@coremat/CmtLayouts/Vertical/Footer"
import CmtVerticalLayout from "../../../../../@coremat/CmtLayouts/Vertical"
import CmtSidebar from "../../../../../@coremat/CmtLayouts/Vertical/Sidebar"
import CmtContent from "../../../../../@coremat/CmtLayouts/Vertical/Content"
import {HEADER_TYPE, SIDEBAR_TYPE} from "../../../../constants/ThemeOptions"
import AppContext from "../../../contextProvider/AppContextProvider/AppContext"
import SidebarToggleHandler from "../../../../../@coremat/CmtLayouts/Vertical/SidebarToggleHandler"

// Local Imports
import NotificationStyles from "./NotificationStyles"

const useStyles = makeStyles(theme => ({
    minimalNoHeader: {
        backgroundColor: "transparent",
        boxShadow: "none",
        "& .Cmt-toggle-menu": {
            color: theme.palette.text.primary,
            marginLeft: 15
        }
    }
}))

const MinimalNoHeader = ({className, children}) => {
    const classes = useStyles()
    const location = useLocation()

    const {
        drawerBreakPoint,
        isSidebarFixed,
        sidebarStyle,
        sidebarSize
    } = React.useContext(AppContext)

    const {authUser} = useSelector(({auth}) => auth)

    const [showMenu, setShowMenu] = React.useState(true)
    const [headerMargin, setHeaderMargin] = React.useState(0)
    const [showFooter, setShowFooter] = React.useState(false)

    React.useEffect(() => {
        if ("settings" in authUser && authUser.settings) {
            let settings = JSON5.parse(authUser.settings)

            setShowMenu(settings["showMenu"])
            setHeaderMargin(parseFloat(settings["header_margin"]))
        }
    }, [authUser])

    React.useEffect(() => {
        if ("settings" in authUser && authUser.settings) {
            let settings = JSON5.parse(authUser.settings)

            let leftFooter = "leftFooter" in settings ? settings["leftFooter"] : false
            let rightFooter = "rightFooter" in settings ? settings["rightFooter"] : false
            let rightFooterDetails = "rightFooterDetails" in settings ? settings["rightFooterDetails"] : false
            let prospectsLeftFooter = "prospects_leftFooter" in settings ? settings["prospects_leftFooter"] : false
            let prospectsRightFooter = "prospects_rightFooter" in settings ? settings["prospects_rightFooter"] : false
            let prospectsRightFooterDetails = "prospects_rightFooterDetails" in settings ? settings["prospects_rightFooterDetails"] : false

            if (location.pathname && location.pathname === "/data/prospects") {
                if (prospectsLeftFooter || prospectsRightFooter || prospectsRightFooterDetails)
                    setShowFooter(true)
                else setShowFooter(false)
            } else {
                if (leftFooter || rightFooter || rightFooterDetails)
                    setShowFooter(true)
                else setShowFooter(false)
            }
        }
    }, [authUser, location.pathname])

    // SETs the notification below the WordPress HEADER
    NotificationStyles({marginTop: headerMargin + 10})

    return (
        <CmtVerticalLayout
            drawerBreakPoint={showMenu ? drawerBreakPoint : null}
            className={clsx("verticalMinimalNoHeaderLayout", className)}
            sidebarWidth={showMenu ? sidebarSize : 0}
        >
            <CmtHeader className={classes.minimalNoHeader} type={HEADER_TYPE.STATIC}>
                <Hidden lgUp>
                    <SidebarToggleHandler
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                    />
                </Hidden>
            </CmtHeader>
            {
                showMenu ?
                    <CmtSidebar
                        type={SIDEBAR_TYPE.MINI}
                        isSidebarFixed={isSidebarFixed}
                        {...sidebarStyle}
                    >
                        <div style={{
                            width: "100%",
                            background: "#F4F4F7",
                            position: "sticky",
                            top: 0,
                            // z-index of the sidebar is 1103 (src/@jumbo/components/AppLayout/partials/SideBar/index.js). So, this value should be < 1103.
                            // Otherwise, this div will go on top of the sidebar when the sidebar will be expanded.
                            zIndex: 1102,
                            // height: (headerMargin + 10 + 13)
                            height: headerMargin
                        }}/>
                        <SidebarHeader/>
                        <SideBar/>
                    </CmtSidebar> : null
            }
            <CmtContent style={{position: "relative"}}>
                {/*<Box style={{width: "100%", border: "2px solid red", backgroundColor: "transparent"}} height={headerMargin}/>*/}
                <div style={{
                    width: "100%",
                    background: "#F4F4F7",
                    position: "sticky",
                    top: 0,
                    // z-index of the sidebar is 1103 (src/@jumbo/components/AppLayout/partials/SideBar/index.js). So, this value should be < 1103.
                    // Otherwise, this div will go on top of the sidebar when the sidebar will be expanded.
                    zIndex: 1102,
                    height: headerMargin
                }}
                />
                {children}
                <ContentLoader/>
            </CmtContent>
            {
                showFooter && (
                    <CmtFooter type="static">
                        <Footer/>
                    </CmtFooter>
                )
            }
        </CmtVerticalLayout>
    )
}

export default MinimalNoHeader
